module.exports = __webpack_public_path__ + "img/recommendLogo1.3791b1ef.png";